<template>
  <div>
    <vue-element-loading :active="isLoading" />
    <v-card class="pcard pcard--purple">
      <div class="pcard-header">
        <div class="pcard-header-left">
          <div class="pcard-icon-wrap" style="background:rgba(255,255,255,0.18)">
            <v-icon color="white" size="22">mdi-bell-outline</v-icon>
          </div>
          <div>
            <p class="pcard-header-sub" style="color:rgba(255,255,255,0.9)">{{ $t('sidebar.general') }}</p>
            <h2 class="pcard-header-title" style="color:#fff!important">{{ $t('pages.notifications') }}</h2>
          </div>
        </div>
        <create-button
          v-if="userType === 'school'"
          allow-director
          @create="create"
        ></create-button>
      </div>
      <v-data-table
        :headers="headers"
        :items="notifications"
        :options.sync="options"
        :server-items-length="totalNotifications"
        class="elevation-1"
        v-model="selected"
      >
        <template v-slot:item.title="{ item }">
          <div class="table-column-title">
            <span v-if="item.data.title">
              {{ item.data.title }}
            </span>
            <span v-else-if="item.data.student.name">
              {{ item.data.student.name }}
            </span>
            <span v-else>-</span>
          </div>
        </template>

        <template v-slot:item.message="{ item }">
          <div
            v-html="displayNotificationType(item)"
            class="table-message"
          ></div>
        </template>

        <template v-slot:item.created_at="{ item }">
          <div class="table-column-date">
            <small>{{ item.created_at | moment('DD/MM/YYYY') }}</small> -
            <small class="text-muted">
              {{ item.created_at | moment('HH:mm') }}
            </small>
          </div>
        </template>

        <template v-slot:item.read_stats="{ item }">
          <div
            v-if="item.recipients_total > 0"
            class="read-cell"
            @click="openRecipients(item)"
          >
            <v-chip
              x-small
              dark
              :color="item.recipients_read === item.recipients_total ? '#388E3C' : '#F57C00'"
            >
              {{ item.recipients_read }}/{{ item.recipients_total }}
            </v-chip>
            <div v-if="item.last_read_at" class="read-cell-date">
              {{ item.last_read_at | moment('DD/MM/YYYY') }} ·
              {{ item.last_read_at | moment('HH:mm') }}
            </div>
          </div>
          <span v-else class="read-cell-empty">—</span>
        </template>
      </v-data-table>
    </v-card>

    <!-- Kush e ka lexuar njoftimin dhe kur -->
    <v-dialog v-model="recipientsDialog" max-width="560" scrollable>
      <v-card>
        <v-card-title class="rc-head">
          <v-icon color="white" size="20" class="mr-2">mdi-account-check-outline</v-icon>
          <span class="rc-head-title">{{ $t('notif.read_by') }}</span>
          <v-spacer></v-spacer>
          <v-btn icon dark small @click="recipientsDialog = false">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <div v-if="recipientsLoading" class="pa-8 text-center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
          <v-simple-table v-else-if="recipients.length > 0" dense>
            <thead>
              <tr>
                <th>{{ $t('table.name') }}</th>
                <th>{{ $t('notif.read_at') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in recipients" :key="r.id">
                <td class="rc-name">{{ r.name }}</td>
                <td>
                  <span v-if="r.read_at" class="rc-read">
                    {{ r.read_at | moment('DD/MM/YYYY') }} ·
                    {{ r.read_at | moment('HH:mm') }}
                  </span>
                  <v-chip v-else x-small outlined color="grey">
                    {{ $t('notif.unread') }}
                  </v-chip>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          <div v-else class="pa-8 text-center grey--text">
            {{ $t('notif.no_recipients') }}
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading';
import CreateButton from '@/components/CreateButton';
import DOMPurify from 'dompurify';
import notificationService from '@/services/NotificationService';

export default {
  components: { VueElementLoading, CreateButton },
  data() {
    return {
      isLoading: false,
      userType: null,
      headers: [
        { text: this.$t('table.title'), value: 'title' },
        { text: this.$t('table.message'), value: 'message' },
        { text: this.$t('table.sent_at'), value: 'created_at' },
        { text: this.$t('notif.read_by'), value: 'read_stats', sortable: false },
      ],
      notifications: [],
      totalNotifications: 0,
      options: {},
      selected: [],
      notificationsLast: notificationService.state,
      recipientsDialog: false,
      recipientsLoading: false,
      recipients: [],
    };
  },
  mounted() {
    this.userType = this.$route.name.split('-')?.[0];
    if (
      this.userType === 'driver' ||
      this.userType === 'parent' ||
      this.userType === 'guardian' ||
      this.userType === 'student'
    ) {
      this.headers = [
        { text: this.$t('table.title'), value: 'title' },
        { text: this.$t('table.message'), value: 'message' },
        { text: this.$t('table.date'), value: 'created_at' },
      ];
    } else {
      this.headers = [
        { text: this.$t('table.title'), value: 'title' },
        { text: this.$t('table.message'), value: 'message' },
        { text: this.$t('table.sent_at'), value: 'created_at' },
        { text: this.$t('notif.read_by'), value: 'read_stats', sortable: false },
      ];
    }
    this.getAllNotifications();
  },
  methods: {
    getAllNotifications() {
      this.isLoading = true;
      const params = {
        page: this.options?.page,
        per_page: this.options?.itemsPerPage,
        order_by: this.options?.sortBy?.[0],
        order_direction:
          this.options?.sortDesc?.[0] === null ||
          this.options?.sortDesc?.[0] === undefined
            ? null
            : this.options?.sortDesc?.[0] === true
            ? 'DESC'
            : 'ASC',
      };
      axios
        .get(`/notifications`, { params })
        .then((response) => {
          this.notifications = response?.data?.data;
          this.totalNotifications = response?.data?.total ?? 0;
          this.selected = this.notifications.filter((item) => !item?.read_at);
        })
        .catch(() => {
          this.$notify({
            title: 'Error',
            text: 'Error while getting notifications',
            type: 'error',
          });
        })
        .then(() => {
          this.isLoading = null;
          notificationService.loadLastNotifications();
        });
    },
    makeLinksClickable(text) {
      if (!text) return '';

      const urlPattern = /((https?:\/\/[^\s]+))/g;
      const emailPattern = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;

      const linked = text
        .replace(
          urlPattern,
          '<a href="$1" target="_blank" rel="noopener">$1</a>'
        )
        .replace(emailPattern, '<a href="mailto:$1">$1</a>');

      return DOMPurify.sanitize(linked);
    },
    displayNotificationType(notification) {
      let message = '';
      if (notification?.type === 'App\\Notifications\\StudentTaken') {
        message = this.$t('navbar.notification_taken');
      } else if (notification?.type === 'App\\Notifications\\StudentDropped') {
        message = this.$t('navbar.notification_dropped');
      } else if (
        notification?.type === 'App\\Notifications\\MessageNotification'
      ) {
        message = notification.data?.message;
      } else if (
        notification?.type === 'App\\Notifications\\PaymentNotification'
      ) {
        message = this.$t('navbar.notification_paid', {
          months: notification?.data?.payment?.months?.join(', '),
        });
      } else {
        message = '-';
      }

      return this.makeLinksClickable(message);
    },
    create() {
      this.$router.push({ name: 'crate-school-notification' });
    },
    openRecipients(item) {
      this.recipients = [];
      this.recipientsLoading = true;
      this.recipientsDialog = true;
      axios
        .get(`/notifications/${item.id}/recipients`)
        .then((response) => {
          this.recipients = response?.data ?? [];
        })
        .catch(() => {
          this.recipients = [];
        })
        .finally(() => {
          this.recipientsLoading = false;
        });
    },
  },
  watch: {
    options: {
      handler() {
        if (this.notifications?.length > 0) {
          this.getAllNotifications(true);
        }
      },
      deep: true,
    },
    notificationsLast: {
      handler(newValue, oldValue) {
        // console.log(
        //   newValue?.lastNotificationsCount,
        //   oldValue?.lastNotificationsCount
        // );
        // if (
        //   newValue?.lastNotificationsCount != oldValue?.lastNotificationsCount
        // ) {
        //   console.log(11111);
        // }
        // this.getAllNotifications();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.pcard { border-radius: 14px !important; overflow: hidden; border: none !important; }
.pcard-header {
  padding: 18px 20px;
  display: flex; align-items: center; justify-content: space-between;
}
.pcard--purple .pcard-header { background: linear-gradient(135deg, #6A1B9A, #AB47BC); }
.pcard-header-left { display: flex; align-items: center; gap: 12px; }
.pcard-icon-wrap {
  width: 40px; height: 40px; border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
}
.pcard-header-sub {
  font-size: 11px; color: #fff !important;
  text-transform: uppercase; letter-spacing: 0.5px;
  margin: 0; font-weight: 600; opacity: 0.88;
}
.pcard-header-title { font-size: 18px; font-weight: 800; color: #fff !important; margin: 0; }

.table-column-title {
  min-width: 130px;
}

.table-message {
  /* Ruaj kryerreshtat dhe rreshtat bosh ashtu si i shkruan autori */
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
  display: block;
  line-height: 1.55;
  max-width: 640px;
}

/* Ne telefon teksti i gjate lexohet keq i rreshtuar djathtas */
::v-deep .v-data-table__mobile-row__cell .table-message {
  text-align: left;
}

.table-column-date {
  min-width: 130px;
}

/* Clear separation between notification rows */
::v-deep .v-data-table tbody tr td {
  padding-top: 14px !important;
  padding-bottom: 14px !important;
  border-bottom: none !important;
}
::v-deep .v-data-table tbody tr:not(:last-child) {
  border-bottom: 2px solid rgba(106, 27, 154, 0.14) !important;
}
::v-deep .v-data-table tbody tr:hover td {
  background: rgba(106, 27, 154, 0.05) !important;
}

.read-cell { cursor: pointer; display: inline-block; }
.read-cell:hover { opacity: 0.75; }
.read-cell-date { font-size: 11px; color: #94a3b8; margin-top: 3px; white-space: nowrap; }
.read-cell-empty { color: #cbd5e1; }
.rc-head { background: linear-gradient(90deg, #6A1B9A, #8E24AA); padding: 12px 16px; }
.rc-head-title { color: #fff; font-size: 15px; font-weight: 700; }
.rc-name { font-size: 13px; font-weight: 500; }
.rc-read { font-size: 12px; color: #475569; }
</style>